import React, { useContext } from 'react';
import { merge } from 'lodash';
import { number, array, bool, object, arrayOf, objectOf, string, instanceOf, element } from 'prop-types';
import PCPContext from '../../utils/context';
import { withSelfFetching } from '../../hoc/withSelfFetching';
import { CarouselHeader } from './CarouselHeader';
import { CarouselFooter } from './CarouselFooter';
import { createDynamicSliderBreakpoints } from './utils';

export const withGigsComponentWrapper = (Component) => {
    const GigsComponentsWrapper = (props) => {
        const {
            sectionName,
            headerTitleClass,
            component: { properties = {}, contextEnrichment = {}, items: { gigs = [] } = {} } = {},
            impressionEnrichment = {},
            sliderBreakpoints,
        } = props;
        const pcpContext = useContext(PCPContext);
        const enrichment = merge(
            {},
            contextEnrichment,
            {
                context: {
                    pageComponentName: sectionName,
                    ...pcpContext,
                },
            },
            impressionEnrichment
        );

        const breakpoints = sliderBreakpoints || createDynamicSliderBreakpoints(gigs.length);

        const gigComponentProps = {
            ...props,
            ...enrichment,
            gigs,
            isExperiential: true,
            sliderBreakpoints: breakpoints,
        };

        const dataEnrichment = enrichment.context;

        return (
            <>
                <CarouselHeader titleClassName={headerTitleClass} dataEnrichment={dataEnrichment} {...properties} />
                <Component {...gigComponentProps} />
                <CarouselFooter dataEnrichment={dataEnrichment} {...properties} />
            </>
        );
    };

    GigsComponentsWrapper.propTypes = {
        sectionName: string,
        component: object.isRequired,
        sliderBaseNum: number,
        sliderBreakpoints: array,
        size: number,
        isLoading: bool,
        isLazy: bool,
        showTranslatedUGC: bool,
        recentlyViewedChoiceGigs: arrayOf(number),
        abTests: object,
        choiceAlgos: objectOf(arrayOf(string)),
        collectProps: object,
        headerTitleClass: string,
        container: instanceOf(element),
        impressionEnrichment: object,
    };

    GigsComponentsWrapper.defaultProps = {
        size: 5,
        sliderBaseNum: 5,
        isLoading: false,
        isLazy: false,
        showTranslatedUGC: false,
        collectProps: {},
        impressionEnrichment: {},
    };

    return withSelfFetching(GigsComponentsWrapper);
};

export default withGigsComponentWrapper;
